"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLowFiUrl = void 0;
const defaults_1 = require("../defaults");
const helpers_1 = require("./helpers");
const TRANSPARENT = 'transparent';
const regexIsFullUrl = /(http?:|)\/\//;
function buildImageUrl(originalPath, image) {
    const { width, height, smartCrop, quality, fitIn, fitInColor } = image;
    // const [, extension] = originalPath.split('.')
    // base url
    let url = '';
    // compat path is a full url or just path
    if (!regexIsFullUrl.test(originalPath)) {
        url += defaults_1.STORYBLOK_BASE_URL;
        if (!originalPath.startsWith('/')) {
            url += '/';
        }
    }
    url += originalPath + '/m';
    if (fitIn) {
        url += '/fit-in';
    }
    if (width || height) {
        url += `/${width || 0}x${height || 0}`;
    }
    if (smartCrop) {
        url += `/smart`;
    }
    const filters = [
        quality && `quality(${quality})`,
        // format && format !== extension && `format(${format})`,
        fitIn && `fill(${(fitInColor || TRANSPARENT).replace('#', '')})`
    ].filter(Boolean);
    url += (0, helpers_1.applyFilters)(filters);
    // fullfil the url format when no any filters or size config
    if (url.endsWith('/m')) {
        url += '/';
    }
    return url;
}
exports.default = buildImageUrl;
function buildLowFiUrl(originalPath, opt = {}) {
    const width = 20;
    let height = undefined;
    // Compat case when croping with different aspect ratio
    if (opt.height && opt.width) {
        height = Math.round((opt.height / opt.width) * width);
    }
    return buildImageUrl(originalPath, {
        width,
        height,
        quality: 10,
        fitIn: opt.fitIn
    });
}
exports.buildLowFiUrl = buildLowFiUrl;
